module.exports = __webpack_public_path__ + "img/orientation-vertical-on.429aa0bb.svg";